import { AppService } from '@services/app/app.service';
import { KeyValue } from '@angular/common';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeader } from '@core/utils';
import { HttpOptions } from '@capacitor/core';

@Injectable({
  providedIn: 'root'
})
export class HttpReqService {
  protected headers: HttpHeader[] = [];

  constructor(private appService: AppService) {}

  /**
   * aggiunge l'header se non già presente
   */
  addHeader(header: HttpHeader): void {
    const index = this.headers.findIndex(x => x.name === header.name);

    if (index < 0) {
      this.headers.push(header);
    }
  }

  /**
   * aggiunge agli headers della richiesta gli header configurati
   */
  setHeadersOnHttpRequest(req: HttpRequest<any>): HttpHeaders {
    let headers = req.headers || new HttpHeaders();

    const list = [
      ...this.getValidHeaders({ url: req.url }),
      ...this.getCommonHeaders()
    ];

    list.forEach(header => {
      headers = headers.set(header.key, header.value);
    });

    return headers;
  }

  /**
   * applica gli headers alla richiesta nativa
   */
  setHeadersOnNativeRequest(req: HttpOptions): HttpOptions {
    const list = [
      ...this.getValidHeaders({ url: req.url }),
      ...this.getCommonHeaders(),
      ...this.getNativeHeaders()
    ];

    if (!req.headers) {
      req.headers = {};
    }

    list.forEach(header => {
      req.headers[header.key] = header.value;
    });

    return req;
  }

  /**
   * restituisce la lista di headers validi per la richiesta
   */
  protected getValidHeaders(req: { url: string }): KeyValue<string, string>[] {
    return this.headers
      .filter(x => x.isAddAllowed(req) && !!x.getValue())
      .map(x => ({
        key: x.name,
        value: x.getValue()
      }));
  }

  /**
   * restituisce la lista di headers comuni da aggiungere
   */
  protected getCommonHeaders(): KeyValue<string, string>[] {
    const list = [
      { key: 'pragma', value: 'no-cache' },
      { key: 'Cache-Control', value: 'no-cache' },
      { key: 'If-Modified-Since', value: 'Mon, 26 Jul 1997 05:00:00 GMT' }
    ];

    const demoDatasetId = this.getDemoDatasetId();

    if (demoDatasetId) {
      list.push({ key: 'Raven-Dataset-Id', value: demoDatasetId });
    }

    return list;
  }

  /**
   * restituisce la lista di headers comuni per le richieste native
   */
  private getNativeHeaders(): KeyValue<string, string>[] {
    return [
      { key: 'Accept', value: 'application/json, text/plain, */*' },
      { key: 'Content-Type', value: 'application/json' },
      { key: 'Referer', value: 'self-revolving-fe' } // header momentaneo, altrimenti non funziona autenticazione con IBM
    ];
  }

  private getDemoDatasetId(): string {
    return (
      this.appService.getEnvironment().demoDatasetId ||
      localStorage.getItem('demoDatasetId')
    );
  }
}
